import {
	TRANSACTIONS_CANCEL,
	TRANSACTIONS_FETCH,
	TRANSACTIONS_REJECT,
	TRANSACTIONS_RESOLVE,
} from "../../types/customer/transactionsTypes";

const initialState = {
	status: "idle",
	allTransactions: null,
	completedTransactions: null,
	failedTransactions: null,
	initiatedTransactions: null,
	transactionNo: null,
};

const transactionsReducer = (state = initialState, action) => {
	switch (action.type) {
		case TRANSACTIONS_FETCH:
			return {
				...state,
				status: "loading"
			};
		case TRANSACTIONS_RESOLVE:
			return {
				...state,
				status: "success",
				allTransactions: action.payload,
				completedTransactions: action.payload.filter(transaction => transaction.status === 'completed'),
				failedTransactions: action.payload.filter(transaction => transaction.status === 'failed'),
				initiatedTransactions: action.payload.filter(transaction => transaction.status === 'initiated'),
				transactionNo: action.payload.length
			};
		case TRANSACTIONS_REJECT:
			return {
				...state,
				status: "failure"
			};
		case TRANSACTIONS_CANCEL:
			return {
				...state,
				status: "idle"
			};
		default:
			return state;
	}
};

export default transactionsReducer;
